<template>
  <el-select
    v-model="id"
    :disabled="disabled"
    :multiple="multiple"
    :clearable="clearable"
    style="width: 100%"
    @change="onChange">
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: 'CustomSelect',
  props: {
    disabled: { type: Boolean, default: false },
    multiple: { type: Boolean, default: false },
    clearable: { type: Boolean, default: false },
    options: { type: Array, default() { return [] } },
    value: { type: [Number, String, Array], default: null }
  },
  computed: {
    id: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    onChange() {
      this.$emit('change')
    }
  }
}
</script>
